import ResearchImage from "../../../../src/components/research/research-image";
import PostgraduateStudyGraphSVG from "../../../../src/content/higher-education/svg/higher-education-graph-4.svg";
import GraphLegend from "../../../../src/components/research/graph-legend";
import * as React from 'react';
export default {
  ResearchImage,
  PostgraduateStudyGraphSVG,
  GraphLegend,
  React
};